import { PublicClientApplication } from "@azure/msal-browser";
import { getEnv } from "./utils/runtimeEnv";

const msalConfig = {
  auth: {
    clientId: getEnv("REACT_APP_ENTRA_CLIENT_ID"),
    authority: getEnv("REACT_APP_ENTRA_AUTHORITY"),
    redirectUri: getEnv("REACT_APP_ENTRA_REDIRECT_URI"),
    postLogoutRedirectUri: getEnv("REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI"),
    /* Block navigation to Microsoft's logout endpoint so logout clears local
       tokens only. Login navigations (/authorize) are allowed through. */
    onRedirectNavigate: (url) => !url.includes("/oauth2/v2.0/logout"),
  },
};

export const loginRequest = { scopes: ["openid"] };
export const apiRequest = {
  scopes: [getEnv("REACT_APP_ENTRA_API_SCOPE")].filter(Boolean),
};
export const msalInstance = new PublicClientApplication(msalConfig);
